import { nodesFlux } from '@candulabs/craft';
import { useMemo } from 'react';
import { createSelector } from 'reselect';

import { useEditor } from 'craft/hooks/useEditor';
import { useEditorSelector } from 'craft/hooks/useEditorSelector';
import { Conditional, CustomNodeData } from 'craft/types';

interface NodeConditional {
  conditional?: Conditional;
  setConditional: (conditional?: Conditional) => void;
}

// for now, we only allow one conditional which will have id 5
export const CONDITIONAL_ID = '5';

export const useNodeConditional = (nodeId: string): NodeConditional => {
  const { actions } = useEditor();
  const conditionalSelector = useMemo(
    () =>
      createSelector(
        nodesFlux.selectors.getNodeCustom(nodeId),
        (custom: CustomNodeData) => (custom?.conditionals ?? {})[CONDITIONAL_ID],
      ),
    [nodeId],
  );
  const conditional: Conditional | undefined = useEditorSelector(conditionalSelector);

  const setConditional = (newConditional?: undefined) => {
    actions.setCustom(nodeId, (custom: CustomNodeData) => {
      if (!newConditional) {
        // eslint-disable-next-line no-param-reassign
        custom.conditionals = undefined;
      } else {
        // @ts-expect-error
        // eslint-disable-next-line no-param-reassign
        custom.conditionals = { [CONDITIONAL_ID]: newConditional };
      }
    });
  };

  return { conditional, setConditional };
};
